/*
* Salla Tab Header Component: has many sizes, styles and loading state.
* You can use these classes to target the elements in the component.
*/

.s-tabs {
  &-selected {

  }
  &-header {

  }
  &-transit {
    
  }
  &-default-background {

  }
  &-active {

  }
}